/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="top_tit" :to="{ name: 'top' , params: { brandPath: $route.params.brandPath}} ">
                        <div class="icn_green">TOPへ</div>
                    </router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l">店舗選択</p>
                </div>
            </div>
        </div>
        <StoreSelect/>
    </div>
</template>

<script>
    import StoreSelect from '@/app/components/StoreSelect.vue'
    export default {
        name: 'manageStoredSelect',
        components: {
            StoreSelect
        }
    }
</script>
